var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 218,
    viewBox: "0 0 309 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 308,
    height: 217,
    rx: 19.5,
    fill: "white",
    stroke: "#D4E1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.284 154.508H126.98V66.6299H176.284V154.508Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.134 110.569C130.134 92.7426 138.55 76.8632 151.655 66.6299C142.072 59.1468 129.977 54.6804 116.832 54.6804C85.7129 54.6804 60.4873 79.7023 60.4873 110.569C60.4873 141.436 85.7129 166.458 116.832 166.458C129.977 166.458 142.072 161.992 151.655 154.508C138.55 144.275 130.134 128.396 130.134 110.569Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M242.763 110.569C242.763 141.436 217.537 166.458 186.418 166.458C173.274 166.458 161.179 161.992 151.591 154.508C164.7 144.275 173.116 128.396 173.116 110.569C173.116 92.7426 164.7 76.8632 151.591 66.6299C161.179 59.1468 173.274 54.6804 186.418 54.6804C217.537 54.6804 242.763 79.7023 242.763 110.569Z",
    fill: "#F79E1B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.0a41ad9f3f43710a2cf8d242af2d2c25.svg";
export { ForwardRef as ReactComponent };